// extracted by mini-css-extract-plugin
export default {"form":"Login-form-c243","center":"Login-center-b2ec"};